/**
 * Layout: Travel information
 * Slug: travel_information
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.travel_information-layout');

	layouts.forEach((layout) => {
		let split = SplitText.create(layout.querySelector(".content-col .pk-heading-text"), { type: "lines" });

		gsap.to(split.lines[1], {
			xPercent: 20,
			scrollTrigger: {
				trigger: layout,
				scrub: false,
				start: "top center",
				end: "bottom center",
				toggleActions: "play reverse play reverse",
				markers: false
			}
		});
	});
});
